<template>
  <el-row class="bg-bordered" type="flex" justify="center" :gutter="24" role="tablist">

    <!-- XOL-583: all three counters always render, 0 included, so every tab
         offers the same Active / Rejected / Closed filters. They used to be
         hidden at 0, which dropped the Rejected/Closed filters from any tab
         with none yet (e.g. Backhaul).
         DashText align="top" puts the count on its own line above the icon.
         With "center" a short count ("0") fits beside the icon while a long
         one ("402") wraps above it, so a zero tile sat shorter than its
         neighbours. -->
    <el-col :span="4" :offset="1" align="center"
      role="tab" :aria-selected="reqStatus === 'active'" :aria-label="'Active requests: ' + rtxActive" tabindex="0"
      @keydown.enter.prevent="showActive" @keydown.space.prevent="showActive">
      <dash-text caption="Active" :value="rtxActive" icon="fa fa-tasks" align="top" color="#0EABDD" caption-color="slategrey" no-plural  :on-click="showActive" />
    </el-col>

    <el-col :span="4" :offset="1" align="center"
      role="tab" :aria-selected="reqStatus === 'rejected'" :aria-label="'Rejected requests: ' + rtxRejected" tabindex="0"
      @keydown.enter.prevent="showRejected" @keydown.space.prevent="showRejected">
      <dash-text caption="Rejected" :value="rtxRejected" icon="fa fa-exclamation-triangle" align="top" color="#F8D83A" caption-color="slategrey" no-plural :on-click="showRejected" />
    </el-col>

    <el-col :span="4" :offset="1" align="center"
      role="tab" :aria-selected="reqStatus === 'closed'" :aria-label="'Closed requests: ' + rtxClosed" tabindex="0"
      @keydown.enter.prevent="showClosed" @keydown.space.prevent="showClosed">
      <dash-text caption="Closed" :value="rtxClosed" icon="fa fa-flag" align="top" color="#64CD75" caption-color="slategrey" no-plural  :on-click="showClosed" />
    </el-col>

  </el-row>

</template>

<script>

export default {

  props: {
    status: {
      type: String,
      default: 'active'
    },

    rejected: {
      type: Number,
      default: null
    },

    active: {
      type: Number,
      default: null
    },

    closed: {
      type: Number,
      default: null
    },

    change: {
      type: Function,
      default: null
    }

  },


  methods: {

    statusChanged () {
      if (this.change) {
        this.change(this.reqStatus)
      }
    },

    showActive () {
      this.reqStatus = 'active'
      this.statusChanged()
    },

    showRejected () {
      this.reqStatus = 'rejected'
      this.statusChanged()
    },

    showClosed () {
      this.reqStatus = 'closed'
      this.statusChanged()
    }

  },


  computed: {
    // XOL-583: derived from the props (they come from the stats XHR and can
    // change after mount), not copied into data(). Cast to Number because the
    // parent sometimes passes strings; null / undefined / NaN show as 0.
    rtxActive () {
      return Number(this.active) || 0
    },

    rtxRejected () {
      return Number(this.rejected) || 0
    },

    rtxClosed () {
      return Number(this.closed) || 0
    }
  },

  data () {
    return {
      reqStatus: this.status
    }
  }


}

</script>
